__turbopack_context__.v({
  "btn": "gallery-dialog-module__wErBgq__btn",
  "close": "gallery-dialog-module__wErBgq__close",
  "content": "gallery-dialog-module__wErBgq__content",
  "dialog": "gallery-dialog-module__wErBgq__dialog",
  "full": "gallery-dialog-module__wErBgq__full",
  "next": "gallery-dialog-module__wErBgq__next",
  "prev": "gallery-dialog-module__wErBgq__prev",
  "thumbnails": "gallery-dialog-module__wErBgq__thumbnails",
  "top": "gallery-dialog-module__wErBgq__top",
});
